import i18n from "i18next";
import type { InitOptions } from "i18next";
import { useEffect, useState } from "react";
import { initReactI18next } from "react-i18next";

export const useI18next = <T>(
  options: InitOptions<T>,
): [boolean, Error | null] => {
  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    /* eslint-disable import/no-named-as-default-member */
    i18n.use(initReactI18next).init(options, (error) => {
      if (error) {
        setError(error);
      } else {
        setLoaded(true);
      }
    });
  }, [options]);

  return [loaded, error];
};
